module.exports = __webpack_public_path__ + "img/Send.d6f77655.svg";